import { loadScript } from '#pplx/frontend/common/loadScript.js';
import { safeRandomUUID } from '#pplx/frontend/common/safeRandomUUID.js';
import { useCallback } from 'react';
const MERGE_AH_SCRIPT_ID = `__merge-ah-script__${safeRandomUUID()}`;
async function loadMergeSdk() {
    await loadScript({
        id: MERGE_AH_SCRIPT_ID,
        src: 'https://ah-cdn.merge.dev/initialize.js',
    });
}
export async function openAgentHandlerLink(config) {
    const linkToken = config?.linkToken;
    if (!linkToken) {
        throw new Error('Link token is required');
    }
    await loadMergeSdk();
    await new Promise((resolve) => {
        window.AgentHandlerLink.initialize({
            ...config,
            linkToken,
            enable_telemetry: false,
            onReady: () => resolve(),
        });
    });
    window.AgentHandlerLink.openLink(config);
}
export function useAgentHandlerLink(config) {
    const open = useCallback(async () => {
        await openAgentHandlerLink(config);
    }, [config]);
    return open;
}
//# sourceMappingURL=useAgentHandlerLink.js.map